import Popover, { PopoverProps } from '@mui/material/Popover';
import React from 'react';

interface VyPopoverMenuInterface extends Omit<Omit<PopoverProps, 'content'>, 'open'> {
  content: (onClose: () => void) => JSX.Element;
}

const VyPopoverMenu = ({ children, transformOrigin = { vertical: 'top', horizontal: 'center' }, content, ...props }: VyPopoverMenuInterface) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <div aria-describedby={id} color="primary" onClick={handleClick}>
        {children}
      </div>
      <Popover id={id} anchorEl={anchorEl} onClose={handleClose} transformOrigin={transformOrigin} {...props} open={open}>
        {content(handleClose)}
      </Popover>
    </div>
  );
};
export default VyPopoverMenu;
